import { render, staticRenderFns } from "./subscriptionStats.vue?vue&type=template&id=36167861&scoped=true"
import script from "./subscriptionStats.vue?vue&type=script&lang=js"
export * from "./subscriptionStats.vue?vue&type=script&lang=js"
import style0 from "./subscriptionStats.vue?vue&type=style&index=0&id=36167861&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36167861",
  null
  
)

export default component.exports